<template>
  <div class="report-card col-3 pt-4">
    <div class="card card-blog h-100">
      <div class="card-header p-0 mt-n4 mx-3">
        <router-link
          class="report-card__image-container d-flex justify-content-center align-items-center
                 shadow-xl border-radius-xl bg-gradient-dark"
          :to="link"
        >
          <img
            v-if="item.visualImage"
            :alt="item.title"
            class="report-card__image img-fluid shadow w-100 h-100 border-radius-xl"
            :src="item.visualImage"
          />
          <i
            v-else
            class="d-block material-icons text-secondary fs-1"
          >
            newspaper
          </i>
        </router-link>
      </div>

      <div class="d-flex flex-column card-body p-3">
        <h5 class="mb-2">
          {{  publishDateString  }} - {{ publishTimeString }}
        </h5>

        <p class="mb-2">{{ item.message }}</p>

        <div class="d-flex align-items-center justify-content-between mt-auto">
          <router-link
            :class="[
              'btn',
              'btn-sm',
              'mb-2',
              { 'btn-outline-primary': item != null },
              { 'btn-primary': item == null },
            ]"
            :to="link"
          >
            {{
              item
                ? 'Lees bericht'
                : 'Bericht toevoegen'
            }}
          </router-link>
          
          <p
            class="btn btn-sm mb-2"
            :class="statusClass"
            to="/dashbaord"
          >
            {{ statusText }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parseDateTimeRange } from '@/helpers/parsers';
import { getDateString, getTimeString } from '@/helpers/datetime'

const ReportStatus = {
  reported: 1,
  inProgress: 2,
  resolved: 3
};

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    link() {
      return this.item 
        ? {
          name: 'show-reportitem',
          params: {
            id: this.item.id,
          },
        }
        : {
          name: 'new-reportitem',
        };
    },
    publishDateString() { return getDateString(new Date(this.item.createDate)); },
    publishTimeString() { return getTimeString(new Date(this.item.createDate)); },

    statusClass() {
      switch (this.item.reportStatus) {
        case ReportStatus.inProgress:
          return 'btn-warning';
        case ReportStatus.resolved:
          return 'btn-success';
        default:
          return 'btn-info'
      }
    },

    statusText() {
      switch (this.item.reportStatus) {
        case ReportStatus.inProgress:
          return 'In behandeling';
        case ReportStatus.resolved:
          return 'Afgehandeld';
        default:
          return 'Aangemeld'
      }
    }
  },

  methods: {
    parseDateTimeRange,
  },
};
</script>

<style scoped lang="scss">
.report-card {
  &:nth-child(n + 5) {
    margin-top: var(--bs-gutter-x);
  }

  &__image {
    object-fit: cover;

    &-container {
      height: 150px;
    }
  }

  &__description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  &__metrics p {
    text-align: right;
    margin-bottom: 0;
    line-height: 1.4;
    font-size: 13px;  
  }
}
</style>
